import { render, staticRenderFns } from "./c-hardware.vue?vue&type=template&id=def880c0&scoped=true&"
import script from "./c-hardware.vue?vue&type=script&lang=js&"
export * from "./c-hardware.vue?vue&type=script&lang=js&"
import style0 from "./c-hardware.vue?vue&type=style&index=0&id=def880c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def880c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VRow})
